var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.err)?_vm._t("error",function(){return [_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('message.failed_to_render')))])]},{"err":_vm.err}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }